// Frontend-only metadata per issue type (icons, icon styling).
// Descriptions come from the Metropolis /meter-issue-types endpoint;
// see IssueDescriptions.ts. Entries without an API counterpart
// (yield_promise_status, shade, power_spike, new, ticket, misc) keep
// their translation keys as fallback.
const ISSUES = {
  connectivity: {
    icon: 'wifi',
  },
  driver_notification: {
    icon: 'bell',
  },
  driver_notification_retrieval: {
    icon: 'bell-slash',
  },
  yield_promise_status: {
    icon: 'file-contract',
    tooltip: 'features.issue_values.yield_promise_status.tooltip',
    extendedTooltip:
      'features.issue_values.yield_promise_status.extended_tooltip',
  },
  zero_yield: {
    icon: 'bolt',
  },
  registration_failed: {
    icon: 'sim-card',
  },
  shade_first_half: {
    icon: 'umbrella-beach',
  },
  shade_second_half: {
    icon: 'umbrella-beach',
  },
  // Combination of first- and second half, for filtering only;
  shade: {
    icon: 'umbrella-beach',
    tooltip: 'features.issue_values.shade.tooltip',
    extendedTooltip: 'features.issue_values.shade.extended_tooltip',
  },
  new: {
    icon: 'rocket',
    tooltip: 'features.issue_values.new.tooltip',
    extendedTooltip: 'features.issue_values.new.extended_tooltip',
  },
  ticket: {
    icon: 'ticket-alt',
    iconClass: 'fa-rotate-45-left',
    tooltip: 'features.issue_values.ticket.tooltip',
    extendedTooltip: 'features.issue_values.ticket.extended_tooltip',
  },
  misc: {
    icon: 'exclamation-triangle',
    tooltip: 'features.issue_values.misc.tooltip',
    extendedTooltip: 'features.issue_values.misc.extended_tooltip',
  },
  power_optimizer_issue: {
    icon: 'meter-bolt',
  },
  power_spike_high: {
    icon: 'wave-pulse',
  },
  power_spike_medium: {
    icon: 'wave-pulse',
  },
  // Combination of p_s- high and medium, for filtering only;
  power_spike: {
    icon: 'wave-pulse',
    tooltip: 'features.issue_values.power_spike.tooltip',
    extendedTooltip: 'features.issue_values.power_spike.extended_tooltip',
  },
  meter_credentials: {
    icon: 'key',
  },
  account_credentials: {
    icon: 'key',
  },
  power_interruption: {
    icon: 'exclamation-triangle',
  },
  voltage_high: {
    icon: 'transformer-bolt',
  },
  yield_sum_low: {
    icon: 'gauge-low',
  },
  yield_sum_medium: {
    icon: 'gauge-med',
  },
};

export default class IssueValues {
  static issues() {
    return ISSUES;
  }
}
